import moment from 'moment'
import React from 'react'

import { COLORS, SKIP_TITLES } from '../Constants'
import { useStateValue } from './StateProvider'
import { getRowColor } from '../Utils'

const Country = () => {
    const [{ darkmode, legendTitles, selected }] = useStateValue()

    return (
        <div className='country'>
            <div className='country__header'>
                <div className='country__icon' style={{
                    backgroundImage: `url(${selected !== null && selected.countryInfo.flag})`
                }}></div>
                <p className='country__title'>{selected !== null && selected.country}</p>
                <p className='lcountry__subtitle'>{selected !== null && selected.continent}</p>
            </div>
            <div className='country__table'>
                {legendTitles.map((title, index) => {
                    if (!SKIP_TITLES.includes(title)) {
                        return <p className='country__label' style={{
                            backgroundColor: getRowColor(COLORS, darkmode, index),
                            padding: selected !== null && '4px'
                        }}>{selected !== null && (title === 'updated' ? moment(selected[title]).startOf('hour').fromNow() : selected[title])}</p> 
                    } 
                })}
            </div>
        </div>
    )
}

export default Country